module.exports = "https://coursera_assets.s3.amazonaws.com/images/8a0e52a84010ec767f36e026cd906c5c.png";